import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AssistedBrowsingService } from '../assisted-browsing.service';
import { NavigationBarComponent } from './navigation-bar.component';
import { SvgIconModule } from 'shared/components/svg-icon/svg-icon.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { NavigationControlsComponent } from './navigation-controls/navigation-controls.component';

@NgModule({
  imports: [
    CommonModule,
    SvgIconModule,
    TranslateModule.forChild(),
    NgbModule
  ],
  providers: [
    AssistedBrowsingService
  ],
  declarations: [
    NavigationBarComponent,
    NavigationControlsComponent
  ],
  exports: [
    NavigationBarComponent
  ]
})
export class NavigationBarModule {}
